// import colors from 'vuetify/es5/util/colors'
const staticSetup = {
	siteName: 'Agenda Tong Shu',
	version: '0.0.2',
	subtitle: 'ztudio Management System',
	copyright: '&copy; '+new Date().getFullYear()+' - Todos los derechos reservados',
	madeWithLove: '<div class="ztd-developed-by">You are safe by <a href="https://www.ztudio.es" title="ztudio Partner Agency" target="_blank"><span><img style="height: 14px; width: auto; margin-left: 5px; position: relative; top: 2px;" src="'+require("@/assets/you-are-safe-by.png")+'" alt="ztudio Partner Agency" /></span></a></div>'
}

const projectLimits = {
	searchMin: 2
}

const typeLogins = {
	type: 'simple',
	data: {
		email: 'administrador',
		password: 'wM3Lz2Le'
	}
}

const theme = {
	primary: '#EFEEE8',
	secondary: '#e8e7e1',
	greylight: '#EFEEE8',
	third: '#A61C1F',
	accent: '#3f51b5',
	error: '#f44336',
	warning: '#ED363F',
	info: '#4a72b2',
	success: '#3AB54A',
	bodybackground: '#EFEEE8',
	navbartext: '#57585A',
	bodytext: '#232224',
	white: '#FFFFFF'
}

// Componentes
import UserList from '@/tipos/usuarios/views/UsersList'
import newUser from '@/tipos/usuarios/views/newUser'
import Configuracion from '@/tipos/configuracion/views/configuracion'
import CodigosList from '@/tipos/codigos/views/CodigosList'
import newCodigo from '@/tipos/codigos/views/newCodigo'

const structure = [
	{
		path: ''
	},
	// {
	// 	path: 'dashboard',
	// 	component: Dashboard,
	// 	name: 'dashboard',
	// },
	{
		path: 'users',
		component: UserList,
		name: 'users',
		meta: {
			actionToolbar: true,
			list: true,
			extraSidebar: true
		}
	},
	{
		path: 'users/:id',
		component: newUser,
		name: 'user',
		meta: {
			actionToolbar: true,
			tabs: true,
			extraSidebar: false
		}
	},
	{
		path: 'configuracion',
		component: Configuracion,
		name: 'configuracion',
		meta: {
			actionToolbar: true,
			list: false,
			extraSidebar: false
		},
	},
	{
		path: 'codigos',
		component: CodigosList,
		name: 'codigos',
		meta: {
			actionToolbar: true,
			list: true,
			extraSidebar: true
		}
	},
	{
		path: 'codigos/:id',
		component: newCodigo,
		name: 'codigo',
		meta: {
			actionToolbar: true,
			tabs: true,
			extraSidebar: false
		}
	},
]


export { theme, staticSetup, structure, projectLimits, typeLogins }
